module.exports = __webpack_public_path__ + "static/media/IMG_1099-5-cropped.f70db40b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/IMG_1099-5-cropped.jpg
// module id = 1313
// module chunks = 0